import Toast from './Toast'

let toasts = []

function toast(arg) {
  const t = new Toast(arg)
  if (toasts && toasts.length) {
    toasts.forEach((item) => {
      item.moveUpAndClose()
    })
  }
  toasts = []
  toasts.push(t)
  return t
}

export default toast
